import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignOTSContract from "./SignOTSContract";
import { formatNumberWithCommas, getDeadlineDate } from "../../AllDateTimeReleventFormate";
import { getProjectProposalById } from "../../../../redux/project/action";
import { getOTSById, getOTSRequestById } from "../../../../redux/ots/action";
import { addpresent } from "../../FewCommonMethods";
import RoleLabel from "../../RoleLabel";
import ClientUserCommonDetails from "../../ClientUserCommonDetails";
import CommonWhiteTooltip from "../../CommonWhiteTooltip";
import ContractView from "../../../CustomComponents/ContractView";
import HomeCommonNavigation from "../../HomeCommonNavigation";
import { penaltytips } from "../../Tooltips/tooltip";

export default function OTSContract() {
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const { id } = useParams();
  const its = location.state?.its || null;

  const otsdetails = useSelector(({ ots: { getotsbyid } }) => getotsbyid);

  useEffect(() => {
    if (its != 'request') {
      dispatch(getOTSById(id));
    }
  }, [id, its]);

  const maimndata = useSelector(({ ots: { otsrequestbyid } }) => otsrequestbyid);

  useEffect(() => {
    if (its == 'request') {
      dispatch(getOTSRequestById(id));
    }
  }, [id]);

  useEffect(() => {
    dispatch(getProjectProposalById(id));
  }, [id]);

  const formatDateString = (dateString) => {
    const dateObj = new Date(dateString);
    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return dateObj.toLocaleDateString("en-US", options);
  };

  const pbi = its == 'request' ? maimndata : otsdetails;

  return (
    <div className="container-fluid contract ots-contract-sec">
      <div className="project-offer project-details col-lg-10 mx-auto">
        <p className="breadcrumbs">
          <a onClick={() => navigate(`/${lan}/searchpackaged`)}>OTS &gt; </a>
          <a onClick={() => navigate(-1)}>{pbi?.title || "OTS details"} &gt;</a> Contract
        </p>
        <div className="col-lg-10 mx-auto ots-contarct-auto">
          <div className="contract-sec cont-modal" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="flex-sec">
              <p>Date : {formatDateString(pbi?.created_on)}</p>
              <p>ID : {pbi?.agreement_id || id}</p>
            </div>
            <div className="website-design">
              <ContractView type={'bxp_agreement'} />
            </div>
            <div className="project-details">
              <div className="flex-sec">
                <p>Project Details</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p>Price</p>
                <p>
                  $ {formatNumberWithCommas(
                    pbi?.price || (Array.isArray(pbi?.milestones) && pbi?.milestones.length > 0 ? pbi.milestones[0].amount : 0)
                  )}
                </p>

              </div>
              <div className="flex-sec flex-sec1">
                <p>Deadline</p>
                <p>{getDeadlineDate(pbi?.duration_type, pbi?.duration)}</p>
              </div>
              {Array.isArray(pbi?.milestones) && pbi?.milestones?.length > 0 &&
                <div className="flex-sec flex-sec1">
                  <p>Payment milestones</p>
                  <p>{pbi?.milestones?.length}</p>
                </div>
              }
            </div>
            {Array.isArray(pbi?.milestones) && pbi?.milestones?.length > 0 &&
              <div className="project-details">
                <div className="flex-sec">
                  <p>Agreed milestones</p>
                </div>
                <div className="table-responsive ots-table-responsive">
                  <table className="table ">
                    <thead>
                      <th>Milestones</th>
                      <th>Deadline</th>
                      <th>Amount</th>
                      <th>
                        <CommonWhiteTooltip title={"Penalty"} info={penaltytips} />
                      </th>
                    </thead>
                    <tbody>
                      {Array.isArray(pbi?.milestones) &&
                        pbi?.milestones.map((item, index) => (
                          <tr>
                            <td>
                              {index + 1}. {item.title}
                            </td>
                            <td>
                              {item.duration}
                              {item?.duration_type == 1
                                ? "Hour"
                                : item?.duration_type == 2
                                  ? "Days"
                                  : item?.duration_type == 3
                                    ? "Weeks"
                                    : item?.duration_type == 4
                                      ? "Months"
                                      : ""}
                            </td>
                            <td>$ {item.amount} </td>
                            <td>{addpresent(item.penalty)}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            }
            <ClientUserCommonDetails pbi={pbi} />
            <SignOTSContract pbi={pbi} />
          </div>
        </div>
      </div>
    </div>
  );
}
